import styles from './ChatEmptyState.module.css';

export function ChatEmptyState() {
  return (
    <div className={styles.emptyState}>
      <h3 className={styles.heading}>Hi I'm KAI. How can I help you?</h3>
      <p className={styles.body}>
        I can explain concepts, unpack worked examples, and help you study the
        material without giving away homework answers.
      </p>
      <ul className={styles.suggestions}>
        <li>Can you explain the main idea from this section?</li>
        <li>What should I focus on before I try the homework?</li>
        <li>Can you compare this concept to an earlier chapter?</li>
      </ul>
    </div>
  );
}
